import { render, staticRenderFns } from "./voicechart.vue?vue&type=template&id=5611cd0f&scoped=true"
import script from "./voicechart.vue?vue&type=script&lang=js"
export * from "./voicechart.vue?vue&type=script&lang=js"
import style0 from "./voicechart.vue?vue&type=style&index=0&id=5611cd0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5611cd0f",
  null
  
)

export default component.exports